import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {formatCurrency, formatNumber} from '@/utilities/helpers'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {DashboardConsultantSearchParams} from '../../types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardConsultantCardEmptyState} from '../dashboard-consultant-hours-card/DashboardConsultantCardEmptyState'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const DashboardReimbursementConsistencyCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardConsultantSearchParams)
    const {isLoading, data} = useGetDashboardConsultants(
        {
            fields: ['cashback'],
            ...searchParams
        },
        {enabled: !!searchParams.consultant}
    )

    const hasConsultant = !!searchParams.consultant

    return (
        <DashboardCard title={t('dashboard:reimbursement_consistency')}>
            {!hasConsultant ? (
                <DashboardConsultantCardEmptyState />
            ) : isLoading ? (
                <Flexbox direction="column" gap={4} fullWidth>
                    <Skeleton width="50%" height={28} />
                    <Flexbox direction="column" gap={2}>
                        <Skeleton width="75%" height={16} />
                        <Skeleton width="65%" height={16} />
                    </Flexbox>
                </Flexbox>
            ) : (
                <Flexbox direction="column" gap={4} fullWidth>
                    <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                        {formatCurrency(data?.cashback?.total ?? 0)}
                    </Text>
                    <ul>
                        <li>
                            <Flexbox align="center" gap={1}>
                                <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                    {formatNumber(data?.cashback?.numberOfAccesses ?? 0)}
                                </Text>
                                <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                    {t('dashboard:accesses_performed')}
                                </Text>
                            </Flexbox>
                        </li>
                        <li>
                            <Flexbox align="center" gap={1}>
                                <Text
                                    palette={data?.cashback?.margin && data.cashback.margin < 0 ? 'danger' : 'success'}
                                    shade="500"
                                    size="textSm"
                                    weight={600}
                                >
                                    {formatCurrency(data?.cashback?.margin ?? 0)}
                                </Text>
                                <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                    {t('dashboard:margin_on_costs')}
                                </Text>
                            </Flexbox>
                        </li>
                    </ul>
                </Flexbox>
            )}
        </DashboardCard>
    )
}
